"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var config = {
    enabled: true,
    debug: false,
    trackOnNextTick: false,
    queryParams: undefined,
    loadScript: true,
    defer: false,
};
exports.default = config;
